
/**
 * Load required plugin.
 */
window.Flatpickr = require('flatpickr');

/**
 * Configure the plugin.
 */

+function($){
  page.registerVendor('Flatpickr');

  page.initFlatpickr = function() {
    
    $('input.flatpickr').flatpickr({
        enableTime: true,
        dateFormat: "d M Y h:i K", 
        minDate: "today",
        maxDate: new Date().fp_incr(30)  ,
        minuteIncrement:30,
        minTime: "10:00",
        maxTime: "19:00",
        allowInput: true,
        "disable": [
            function(date) {
                return (date.getDay() === 0);

            }
        ]
    });

  }

}(jQuery);



